import * as types from '../actions/commonActions';

const initialState = {
    isAuthorized: undefined,
    instanceId: "",
    userInfo: {
        userName: ""
    },
    userRights: {},
    roles: {},
    loading: false,
    message: {
        text: "",
        html: false
    },
    environment: ""
};

export default function commonReducer(state = initialState, action) {
    switch (action.type) {
        case types.AUTHORIZED:
            return {
                ...state,
                roles: action.data.roles,
                userInfo: action.data.userInfo,
                userRights: action.data.userRights,
                environment: action.data.environment,
                isAuthorized: action.data.isAuthorized,
                instanceId: action.data.instanceId,
            };
        case types.LOGOUT:
            return {
                ...initialState,
                isAuthorized: false
            };
        case types.UNAUTHORIZED:
            return {
                ...initialState,
                isAuthorized: false,
                instanceId: action.data.instanceId,
            };
        case types.LOADING:
            return {
                ...state,
                loading: action.value
            };
        case types.SET_MESSAGE:
            return {
                ...state,
                message: action.value,
                loading: false
            };
        default:
            return state;
    }
}